"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasReadonlyArea = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../../../utils");
var color_1 = require("../../constants/color");
var bit_matrix_to_image_data_1 = require("../../functions/bit-matrix-to-image-data");
exports.CanvasReadonlyArea = (0, react_1.memo)(function (_a) {
    var canvasSizeInput = _a.canvasSize, readonlyArea = _a.readonlyArea;
    var canvasSize = (0, react_1.useMemo)(function () { return (0, utils_1.IRectSize)(readonlyArea); }, [readonlyArea]);
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        (0, utils_1.resetAndDrawOnCanvas)(context, canvasSize, function () {
            context.putImageData((0, bit_matrix_to_image_data_1.bitMatrixToImageData)(readonlyArea, color_1.readonlyAreaColor, context.createImageData(canvasSize.width, canvasSize.height)), 0, 0);
        });
    }, [context, canvasSize, readonlyArea]);
    var canvasStyle = (0, react_1.useMemo)(function () { return ({ width: canvasSizeInput.width, height: canvasSizeInput.height }); }, [canvasSizeInput]);
    return (react_1.default.createElement("canvas", { style: canvasStyle, ref: canvasRef, height: readonlyArea.height, width: readonlyArea.width }));
});
exports.CanvasReadonlyArea.displayName = 'CanvasReadonlyArea';
